import RoomLaserCrossControl from './RoomLaserCrossControl.vue';
import RoomLaserCross from './RoomLaserCross.vue';
export { RoomLaserCrossControl };
export default RoomLaserCross;
